import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { GiftVoucherService } from 'src/app/services/gift-voucher.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-gift-voucher',
    templateUrl: './checkout-payment-gift-voucher.page.html',
    styleUrls: ['./checkout-payment-gift-voucher.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutPaymentGiftVoucherPage implements OnInit {

    @ViewChild('gift_voucher_code_input', { static: false }) gift_voucher_code_input: IonInput;

    gift_voucher = null;
    person_gift_vouchers = null;
    gift_voucher_code = null;
    cart = null;
    spinner = null;
    payment_amount = null;

    params = {
        is_paid: true,
        is_expired: false,
        has_remaining_balnce: true
    };

    payment = {
        method: 'gift_voucher',
        price: null,
        label:'Gift voucher'
    };

    selectOptions: any = {
        cssClass: 'wide-select'
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private cartService: CartService,
        private giftVoucherService: GiftVoucherService
    ) { }

    ngOnInit() {
        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                this.params['currency_id'] = this.cart.currency.id;
                if (cart['person']) {
                    let params = {
                        is_paid: true,
                        is_expired: false,
                        has_remaining_balance: true,
                        person_id: cart['person'].id,
                        currency_id: cart['currency'].id
                    };
                    this.presentSpinner("Loading gift vouchers").then(() => {
                        this.giftVoucherService.getGiftVouchers(params).then((gift_vouchers: any) => {
                            if (gift_vouchers) {
                                for (let i = 0; i < cart['payments'].length; i++) {
                                    for (let j = 0; j < gift_vouchers.length; j++) {
                                        if (this.cart['payments'][i].method == 'gift_voucher' && this.cart['payments'][i].gift_voucher_id == gift_vouchers[j].id) {
                                            gift_vouchers.splice(j, 1);
                                        }
                                    }
                                }
                                this.person_gift_vouchers = gift_vouchers;
                                this.spinner.dismiss();
                            }
                        })
                        .catch((error: any) => {
                            this.spinner.dismiss();
                            this.presentAlert("We couldn't find any gift vouchers. Please try again.", "");
                        });
                    });
                }
            }
        });

    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.gift_voucher_code_input) {
                this.gift_voucher_code_input.setFocus();
            }
        }, 200);
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }

    addPayment() {

        if(this.payment.price > this.gift_voucher.remaining_balance) {
            this.payment.price = this.gift_voucher.remaining_balance;
        }

        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }

        this.payment['gift_voucher_id'] = this.gift_voucher.id;
        
        let allow_add_payment = true;
        
        for(let i = 0; i < this.cart['payments'].length; i++) {
            if(this.cart['payments'][i].method == 'gift_voucher' && this.cart['payments'][i].gift_voucher_id == this.payment['gift_voucher_id']) {
                allow_add_payment = false;
            }
        }
        
        if(allow_add_payment) {
            this.cartService.addPayment(this.payment).then(() => {
                this.modalController.dismiss();
            });
        }
        else {
            this.presentAlert("This gift voucher has already been used as a payment", "");
            this.gift_voucher = null;
        }

    }

    close() {
        this.modalController.dismiss();
    }

    findGiftVoucher() {
        this.presentSpinner("Loading gift voucher").then(() => {
            this.giftVoucherService.getGiftVoucherByCode(this.gift_voucher_code, this.params).then((gift_voucher) => {
                if (gift_voucher) {
                    this.gift_voucher = gift_voucher;
                    if(this.gift_voucher.remaining_balance >= this.cart.amount_due) {
                        this.payment.price = this.cart.amount_due;
                        this.payment_amount = this.cart.amount_due;
                    }
                    else {
                        this.payment.price = this.gift_voucher.remaining_balance;
                        this.payment_amount = this.gift_voucher.remaining_balance;
                    }
                    this.spinner.dismiss();
                }
            })
            .catch((error: any) => {
                this.spinner.dismiss();
                this.presentAlert("We couldn't find that gift voucher. Please try again.", "");
            });
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    validateCode() {
        let validated = true;
        if (this.gift_voucher_code == null || this.gift_voucher_code.trim() === "") {
            validated = false;
            this.presentAlert("Please enter a voucher code", "");
        }
        if (validated) {
            this.findGiftVoucher();
        }
    }

    setCode(code) {
        this.gift_voucher_code = code;
        this.findGiftVoucher();
    }

}
